/*jslint browser */
/*global process */

var $ = jQuery;

/**
 *
 */
export default abstract class AbstractRouting
{
    /**
     *
     * @protected
     */
    protected appSignature: string;

    /**
     *
     * @param appSignature
     */
    constructor(appSignature: string) {
        this.appSignature = appSignature
    }

    /**
     *
     */
    public route(): void {
        const routing = this;
        $('.' + this.appSignature).each(function () {
            const app = $(this).data('app');

            if(app !== '') {
                console.log('Run ' + routing.appSignature + '-' + app + ' app');
                routing.execute(app);
            }
        });
    }

    /**
     *
     * @param app
     * @private
     */
    protected abstract execute(app: string): void;
}